import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

export function TemplateFormFields() {
  return (
    <>
      <Stack gap={2}>
        <BlockValueTemplateField fieldName="config.ehrInformationId" label="EHR Information ID" />
        <BlockValueTemplateField fieldName="config.templateId" label="Template Id" />
      </Stack>
    </>
  );
}
